import React, { useRef } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Formsy from "formsy-react";
import { useAsyncSetState } from "use-async-setstate";
import { useMutation } from "@apollo/client";
import "../../style/custom/change-password.scss";
import TextField from "../bootstrap/input";
import Modal from "../bootstrap/modal";
import { setPasswordMutation } from "../logic/user";
import SuccessRequest from "./portal-subcomponents/success-request";

export default function ChangePassword(props) {
  const [state, setState] = useAsyncSetState({
    processing: false,
    error: "",
  });
  const [successRequestState, setSuccessRequestState]  = useAsyncSetState(false);
  const [canSubmit, setCanSubmit] = useAsyncSetState(false);
  const { onClose, user } = props;
  const formRef = useRef(null);

  const [setPassword] = useMutation(setPasswordMutation);

  async function handleSubmit({ password, newpassword, confirmpassword }) {
    await setState((prevState) => ({ ...prevState, processing: true }));
    try {
      if (confirmpassword !== newpassword) {
        return setState((prevState) => ({
          ...prevState,
          error: "Passwords don't match",
          processing: false,
        }));
      }
      if (password === newpassword) {
        return setState((prevState) => ({
          ...prevState,
          error: "New password cannot be same as old password",
          processing: false,
        }));
      }

      const result = await setPassword({
        variables: {
          id: user?.id,
          password: newpassword,
          oldPassword: password,
        },
      });

      console.log({result});
      await setState((prevState) => ({ ...prevState, processing: false }));
      return await setSuccessRequestState(true);
    } catch (error) {
      console.log({error});
      return setState((prevState) => ({ ...prevState, processing: false, error: error?.message }));
    }
  }

  return (
    <>
      {successRequestState ?
      <SuccessRequest onClose={onClose} text={"password"}/>
      :
      <Modal
        show
        onClose={async () => onClose()}
      >
        <Formsy className="change-password-form" 
          ref={formRef} 
          onValid={() => setCanSubmit(true)}
          onValidSubmit={async (data) => handleSubmit(data)}
        >
          {state.error && (
            <Row>
              <Col>
                <div className="vw-paper vw-notification error">
                  <i
                    className="fas fa-exclamation-circle"
                  />
                  {state.error}  
                </div>
              </Col>
            </Row>
          )}
          <div className="change-password-container">
            <div className="change-password-heading">
              <p className="change-password-title">{"Change Password"}</p>
            </div>
            <div className="field-row-old-password">
              <TextField
                inline
                label={"Old Password"}
                hideRequiredMark={true}
                name="password"
                placeholder={"Old Password"}
                type="password"
                disabled={state.processing}
                required
              />
            </div>
            <div className="field-row-new-password">
              <TextField
                inline
                hideRequiredMark={true}
                name="newpassword"
                placeholder={"New Password"}
                type="password"
                label={"New Password"}
                disabled={state.processing}
                required
              />
            </div>
            <div className="field-row-confirm-password">
              <TextField
                inline
                hideRequiredMark={true}
                name="confirmpassword"
                label={"Confirm Password"}
                placeholder={"Confirm Password"}
                type="password"
                disabled={state.processing}
                required
              />
            </div>
            <div className="change-password-actions">
              <div className="change-password-buttons">
                <div className="cancel-change-pw">
                  <Button
                    type="button"
                    variant="black-text"
                    disabled={state.processing}
                    onClick={async () => {
                      return onClose();
                    }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
                <div className="save-change">
                  <Button
                    className="blue-btn-outline"
                    type="submit"
                    disabled={state.processing || !canSubmit}
                    onClick={() => formRef.current.submit()}
                  >
                    {"Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Formsy>
      </Modal>
      }
    </>
  );
}
